var productionMode = false;
const urlStart = 'https://smpm-sp-unit-dash.qtrust.id';

export default {productionMode , urlStart};
